import { CalendarDate } from '@internationalized/date';

const YEARS_OFFSET = 200;
const currentYear = new Date().getFullYear();

export const MIN_YEAR = 1600;
export const maxYear = currentYear + YEARS_OFFSET;

export const MAX_VALUE = new CalendarDate(maxYear, 12, 31);
export const MIN_VALUE = new CalendarDate(MIN_YEAR, 1, 1);

export const MIN_NUMBER_OF_VISIBLE_YEARS_FOR_DESKTOP = 15;
